import { render, staticRenderFns } from "./show-list-modal.vue?vue&type=template&id=0f0a0846&scoped=true&"
import script from "./show-list-modal.vue?vue&type=script&lang=js&"
export * from "./show-list-modal.vue?vue&type=script&lang=js&"
import style0 from "./show-list-modal.vue?vue&type=style&index=0&id=0f0a0846&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0a0846",
  null
  
)

export default component.exports